import { AppConstants } from "../../../../constants/constant";
import IdentifyCountryCode from "./IdentifyCountryCode";

export const OptinCheck = (formValues, setFormValues) => {
  if (!formValues?.zipcode) {
    return null;
  }

  const countryCode = IdentifyCountryCode(formValues.zipcode);
  const isServiceReminderTrue = formValues.servicereminder === "true";
  const hideOptinTerms = countryCode === AppConstants.COUNTRY_CA;

  setFormValues((prev) => ({
    ...prev,
    optIn:
      countryCode === AppConstants.COUNTRY_US ? isServiceReminderTrue : false,
    emailOptOut:
      countryCode === AppConstants.COUNTRY_CA ? !isServiceReminderTrue : false,
    hideOptinTerms,
  }));
};
